const initialState = {
  data: [],
}

const customersReducer = (state = initialState, action) => {
  switch (action.type) {
      case 'UPDATE_CUSTOMERS': {
          return {
              data: action.payload,
          }
      }

      default:
          return state;
  }
}

export default customersReducer;
